// extracted by mini-css-extract-plugin
export default {"main":"ListActions_main__9ef8a","actions":"ListActions_actions__rzWA7"};